import { Switch } from 'react-router-dom';
import PrivateRoute from '@/routes/PrivateRoute';
import ManageUserListPage from '@/components/pages/manage/ManageUserListPage';
import ManageCompanyInfoPage from '@/components/pages/manage/ManageCompanyInfoPage';
import { Redirect } from 'react-router';
import ManageSolutionPage from '@/components/pages/manage/ManageSolutionPage';
import ManageBillListPage from '@/components/pages/manage/ManageBillListPage';
import ManageUsageHistoryPage from '@/components/pages/manage/ManageUsageHistoryPage';
import ManagePage from '@/components/pages/manage/ManagePage';

const ManageRoute = () => {
  return (
    <Switch>
      <PrivateRoute exact path="/manage/company/info" component={ManageCompanyInfoPage} />
      <Redirect path="/manage/company" to="/manage/company/info" />
      <PrivateRoute exact path="/manage/solution" component={ManageSolutionPage} />
      <PrivateRoute exact path="/manage/bill/list" component={ManageBillListPage} />
      <Redirect path="/manage/bill" to="/manage/bill/list" />
      <PrivateRoute exact path="/manage/usage/history" component={ManageUsageHistoryPage} />
      <Redirect path="/manage/usage" to="/manage/usage/history" />
      <PrivateRoute path="/manage/user/info" component={ManagePage} />
      <PrivateRoute b2b path="/manage/user/list" component={ManageUserListPage} />
      <Redirect path="/manage" to="/manage/user/info" />
    </Switch>
  );
};

export default ManageRoute;
